module.exports = __webpack_public_path__ + "img/Xgrow-8-pt.a01a11e3.png";